import React from "react"
import { IntegracaoFoodyDeliveryContextProvider } from "./context/IntegracaoFoodyDeliveryContextProvider"
import { IntegracaoFoodyDelivery } from "./IntegracaoFoodyDelivery"

export function Index() {
    return (
        <IntegracaoFoodyDeliveryContextProvider>
            <IntegracaoFoodyDelivery />
        </IntegracaoFoodyDeliveryContextProvider>
    )
}
